import fetch from '@adc/fetch'
import configment from '@adc/configment'
import { utils } from '@adc/ui-morpheus'

export const fetchTransactionsSeek = async (req, fetchOptions) => {
  //  TODO use this when available in seek graph
  // const seeker = seek
  //     .for('TRANSACTIONS')
  //     .operationName('fetchAllTransactionsSeek')
  //     .dsl({ all: {} })
  //     .fields([
  //         'transaction_urn',
  //         "associated_urns.intake_source_urn",
  //         "associated_urns.intake_batch_urn",
  //         "associated_urns.organization_urn",
  //         "associated_urns.salesforce_account_urn",
  //         "associated_urns.salesforce_file_intake_record_urn",
  //         "associated_urns.consumer_listing_intake_urn",
  //         "associated_urns.intake_property_lead_urn",
  //         "associated_urns.property_urn",
  //         "associated_urns.listing_urn",
  //         "associated_urns.event_urn",
  //         "associated_urns.venue_urn",
  //         "associated_urns.online_segment_urn",
  //         "associated_urns.live_auction_segment_urn",
  //     ])
  //     .sortByField(sortBy[0].field, sortBy[0].direction)
  //     .size(size)
  //     .offset(offset)

  const { offset, size, sortBy, filterBy } = fetchOptions
  const query = utils.elasticSearch.buildQuery(filterBy)

  const res = await fetch(
    `${configment.get(
      'RESI_CS_SEEK'
    )}/resi/seek/v1/auction-transactions/search`,
    {
      req,
      method: 'POST',
      body: {
        query,
        sort: sortBy,
        offset,
        size,
      },
    }
  )

  return res.body
}
